var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-col lg:w-1/2 w-full mb-base"},[_c('pulse-loader',{attrs:{"loading":_vm.loading}}),(!_vm.loading)?_c('statistics-card-line',{attrs:{"stats":_vm.stats,"icon":_vm.icon,"type":"area"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }